$(function() {
    if ($(".contenido-landing").length > 0 ){

        var otraInformacionLanding = false;
        if ($(".contenido-otra-informacion").length > 0 ){
            otraInformacionLanding = true;
        }

        function contenidoOtraInformacionLAnding() {
            $(window).trigger('resize');
        }

        $('.contenido-landing').each( function(){
            $(this).find(".swiper-wrapper").css('opacity','0');
            if($(this).offset().top < $(window).height()){
                $(this).find(".contenido-title").animate({'opacity':'1'},500);
                $(this).find(".swiper-wrapper").animate({'opacity':'1'},1000);
                $(this).find(".btns-block").animate({'opacity':'1'},1500);
            }
        });
        
        /* Every time the window is scrolled ... */
        $(window).scroll( function(){
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            /* Check the location of each desired element */
            $('.contenido-landing .swiper-wrapper').each( function(){
                
                var bottom_of_object = $(this).offset().top + 20;
                /* If the object is completely visible in the window, fade it it */
                if( bottom_of_window > bottom_of_object ){
                    $(this).animate({'opacity':'1'},1000);
                }

                if (otraInformacionLanding){
                    contenidoOtraInformacionLAnding();
                }
                
            }); 

            $('.contenido-landing .contenido-title').each( function(){
                
                var bottom_of_object = $(this).offset().top + 20;
                /* If the object is completely visible in the window, fade it it */
                if( bottom_of_window > bottom_of_object ){
                    $(this).animate({'opacity':'1'},500);
                }


                if (otraInformacionLanding){
                    contenidoOtraInformacionLAnding();
                }
                
            }); 

            $('.contenido-landing .btns-block').each( function(){
                
                var bottom_of_object = $(this).offset().top + 20;
                /* If the object is completely visible in the window, fade it it */
                if( bottom_of_window > bottom_of_object ){
                    $(this).animate({'opacity':'1'},1500);
                }

                if (otraInformacionLanding){
                    contenidoOtraInformacionLAnding();
                }
                
            });
        
        });
    }
    
});